export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_h2a-h2b-solutions/artifacts/rtm9ga8n_logo.png";

export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      services: "Services",
      workerApp: "For Workers",
      gallery: "Gallery",
      contact: "Contact Us",
      applyNow: "Hire Workers",
    },
    topbar: {
      english: "English",
      spanish: "Español",
    },
    hero: {
      brand: "AGNM",
      brandSub: "Contracting LLC",
      titleA: "Reliable H-2A Workforce",
      titleB: "For Your Farm",
      subtitle:
        "Michigan-based labor contractor providing dependable, hardworking H-2A agricultural crews so your farm hits every harvest, on time, every season.",
      ctaPrimary: "Hire Workers",
      ctaSecondary: "Talk to an Owner",
    },
    features: [
      {
        title: "Crews That Show Up",
        body: "Vetted, dependable H-2A workers ready to work from day one.",
        icon: "users",
      },
      {
        title: "We Handle The Paperwork",
        body: "DOL job orders, USCIS petitions, consular processing — done for you.",
        icon: "leaf",
      },
      {
        title: "A True Partner",
        body: "We work side by side with your farm to make every season a success.",
        icon: "handshake",
      },
      {
        title: "Compliance You Can Trust",
        body: "Wages, housing, transport — every rule followed, every season.",
        icon: "shield",
      },
    ],
    about: {
      kicker: "Who We Are",
      title: "A Michigan partner your farm can count on",
      body:
        "AGNM Contracting LLC is a family-owned farm labor contractor based in Michigan, founded by brothers Norberto Monroy and Abraham Garcia. We give American growers a partner that actually answers the phone — handling everything from H-2A petitions and visa processing to housing, transportation and on-site crew leadership so you can focus on your operation.",
      cta: "See How We Help Your Farm",
    },
    services: {
      kicker: "Our Services",
      items: [
        {
          title: "Farm Labor Contracting",
          body: "Supplying skilled and dependable workers for all your agricultural needs.",
          icon: "farmer",
        },
        {
          title: "Seasonal & Harvest Crews",
          body: "Providing seasonal labor solutions for planting, growing and harvest.",
          icon: "leaf",
        },
        {
          title: "Field Labor",
          body: "Experienced workers for all types of field work and crop production.",
          icon: "sprout",
        },
        {
          title: "Transportation Services",
          body: "Safe and reliable transportation for workers.",
          icon: "truck",
        },
        {
          title: "Compliance & Support",
          body: "Full support with H-2A compliance and workforce management.",
          icon: "clipboard",
        },
      ],
    },
    gallery: {
      kicker: "Gallery",
      title: "From The Fields",
    },
    contact: {
      kicker: "Contact Us",
      subKicker: "We Are Here To Help",
      body:
        "Reach out to us for more information about our services or to discuss your farm labor needs.",
      serviceArea: "Service Area",
      serviceAreaBody: "Proudly serving farms across the United States.",
      formTitle: "Send a message",
      success: "Thanks — we received your message and will be in touch shortly.",
      error: "Something went wrong. Please try again or call us directly.",
      submitting: "Sending...",
      submit: "Send message",
      fields: {
        name: "Full name",
        email: "Email",
        phone: "Phone (optional)",
        company: "Company / farm (optional)",
        audience: "I am a...",
        visa: "Visa type",
        message: "Message",
      },
      audienceOptions: {
        employer: "Employer / Farm",
        worker: "Worker",
        general: "Just exploring",
      },
      visaOptions: {
        H2A: "H-2A (Agricultural)",
        unsure: "I don't know yet",
      },
    },
    footer: {
      copyright: "AGNM Contracting LLC. All Rights Reserved.",
    },
  },

  es: {
    nav: {
      home: "Inicio",
      about: "Nosotros",
      services: "Servicios",
      workerApp: "Solicitud de Trabajador",
      gallery: "Galería",
      contact: "Contáctenos",
      applyNow: "Aplicar Ahora",
    },
    topbar: {
      english: "English",
      spanish: "Español",
    },
    hero: {
      brand: "AGNM",
      brandSub: "Contracting LLC",
      titleA: "Mano de Obra H-2A Confiable",
      titleB: "Para Su Granja",
      subtitle:
        "Contratista laboral con sede en Michigan que provee cuadrillas agrícolas H-2A confiables y dedicadas para que su granja cumpla cada cosecha, a tiempo, cada temporada.",
      ctaPrimary: "Contratar Trabajadores",
      ctaSecondary: "Hablar con un Dueño",
    },
    features: [
      {
        title: "Cuadrillas Que Llegan a Tiempo",
        body: "Trabajadores H-2A verificados y confiables, listos desde el primer día.",
        icon: "users",
      },
      {
        title: "Nosotros Hacemos los Trámites",
        body: "Órdenes DOL, peticiones USCIS, procesamiento consular — hecho por usted.",
        icon: "leaf",
      },
      {
        title: "Un Verdadero Socio",
        body: "Trabajamos lado a lado con su granja para que cada temporada sea un éxito.",
        icon: "handshake",
      },
      {
        title: "Cumplimiento de Confianza",
        body: "Salarios, vivienda, transporte — cada regla seguida, cada temporada.",
        icon: "shield",
      },
    ],
    about: {
      kicker: "Quiénes Somos",
      title: "Sobre AGNM Contracting LLC",
      body:
        "AGNM Contracting LLC es una empresa de confianza dedicada a proporcionar trabajadores agrícolas confiables y con experiencia a granjas en todo Estados Unidos. Nos especializamos en el programa de visa H-2A, conectando personas trabajadoras con grandes oportunidades y ayudando a las granjas a cubrir sus necesidades laborales durante las temporadas críticas.",
      cta: "Conozca Más Sobre Nosotros",
    },
    services: {
      kicker: "Nuestros Servicios",
      items: [
        {
          title: "Contratación de Mano de Obra Agrícola",
          body: "Suministrando trabajadores calificados y confiables para todas sus necesidades agrícolas.",
          icon: "farmer",
        },
        {
          title: "Cuadrillas Estacionales y de Cosecha",
          body: "Soluciones laborales para siembra, cultivo y cosecha.",
          icon: "leaf",
        },
        {
          title: "Trabajo de Campo",
          body: "Trabajadores con experiencia para todo tipo de trabajo de campo y producción.",
          icon: "sprout",
        },
        {
          title: "Servicios de Transporte",
          body: "Transporte seguro y confiable para los trabajadores.",
          icon: "truck",
        },
        {
          title: "Cumplimiento y Soporte",
          body: "Soporte completo con cumplimiento H-2A y gestión de personal.",
          icon: "clipboard",
        },
      ],
    },
    gallery: {
      kicker: "Galería",
      title: "Desde el Campo",
    },
    contact: {
      kicker: "Contratar Trabajadores",
      subKicker: "Hablemos de Su Temporada",
      body:
        "Cuéntenos sobre su operación — cultivo, número de trabajadores, fechas — y un cofundador le contactará personalmente dentro de un día hábil.",
      serviceArea: "Área de Servicio",
      serviceAreaBody: "Orgullosamente sirviendo granjas en Michigan.",
      formTitle: "Solicitar trabajadores",
      success: "Gracias — recibimos su mensaje y nos pondremos en contacto pronto.",
      error: "Algo salió mal. Inténtelo de nuevo o llámenos directamente.",
      submitting: "Enviando...",
      submit: "Enviar mensaje",
      fields: {
        name: "Nombre completo",
        email: "Correo",
        phone: "Teléfono (opcional)",
        company: "Empresa / granja (opcional)",
        audience: "Yo soy...",
        visa: "Tipo de visa",
        message: "Mensaje",
      },
      audienceOptions: {
        employer: "Empleador / Granja",
        worker: "Trabajador",
        general: "Solo explorando",
      },
      visaOptions: {
        H2A: "H-2A (Agrícola)",
        unsure: "Aún no sé",
      },
    },
    footer: {
      copyright: "AGNM Contracting LLC. Todos los derechos reservados.",
    },
  },
};

export const owners = [
  {
    name: "Norberto Monroy",
    email: "norberto.monroy@agnmusa.com",
    phone: "269-464-3114",
  },
  {
    name: "Abraham Garcia",
    email: "abraham.garcia@agnmusa.com",
    phone: "269-503-3718",
  },
];

export const HERO_BG = "/images/generated/hero_corn_sunset.jpg";
export const ABOUT_IMG = "/images/generated/corn_workers_1.jpg";
export const WHY_IMGS = [
  "/images/generated/watermelon_harvest_1.jpg",
  "/images/generated/corn_workers_2.jpg",
  "/images/generated/watermelon_harvest_2.jpg",
];
export const GALLERY_IMGS = [
  "/images/generated/watermelon_harvest_1.jpg",
  "/images/generated/corn_workers_1.jpg",
  "/images/generated/watermelon_harvest_2.jpg",
  "/images/generated/corn_workers_2.jpg",
];

export const STATS = [
  { value: 50, suffix: "+", label_en: "Partner Farms", label_es: "Granjas Asociadas" },
  { value: 500, suffix: "+", label_en: "Workers Placed", label_es: "Trabajadores Colocados" },
  { value: 100, suffix: "%", label_en: "H-2A Compliant", label_es: "Cumplimiento H-2A" },
  { value: 10, suffix: "+", label_en: "Years Combined Experience", label_es: "Años de Experiencia" },
];

export const WHATSAPP_PHONE = "12694643114"; // E.164 without + for wa.me link

export const WHY_REASONS = {
  en: [
    {
      title: "Family-Run, Hands-On",
      body: "Owned and operated by brothers Norberto and Abraham — you talk directly to a decision-maker, not a call center.",
    },
    {
      title: "100% H-2A Compliant",
      body: "Every petition, every wage, every contract — done by the book so your operation stays protected.",
    },
    {
      title: "Bilingual From Field to Office",
      body: "Spanish and English speakers at every level. Clear communication on day one of the season.",
    },
  ],
  es: [
    {
      title: "Empresa Familiar, Trato Personal",
      body: "Dirigida por los hermanos Norberto y Abraham — habla directamente con un dueño, no con un centro de llamadas.",
    },
    {
      title: "100% Cumplimiento H-2A",
      body: "Cada petición, cada salario, cada contrato — hecho según las reglas para proteger su operación.",
    },
    {
      title: "Bilingües del Campo a la Oficina",
      body: "Hablantes de español e inglés en cada nivel. Comunicación clara desde el primer día.",
    },
  ],
};

export const COMPARE = null; // Removed — AGNM specializes in H-2A only

export const TESTIMONIALS = {
  en: [
    { quote: "AGNM handled our H-2A paperwork without a hitch. The crew showed up on time, ready to work, and stayed the full season.", name: "Apple orchard owner", role: "Michigan" },
    { quote: "Norberto and Abraham treat my guys like family. That matters when you're 1,500 miles from home.", name: "Crew leader", role: "Texas" },
    { quote: "The bilingual supervision made a real difference. Communication was clear from day one.", name: "Landscaping company", role: "Florida" },
  ],
  es: [
    { quote: "AGNM manejó nuestra documentación H-2A sin problemas. La cuadrilla llegó a tiempo, lista para trabajar, y se quedó toda la temporada.", name: "Dueño de huerto", role: "Michigan" },
    { quote: "Norberto y Abraham tratan a mis muchachos como familia. Eso importa cuando estás lejos de casa.", name: "Líder de cuadrilla", role: "Texas" },
    { quote: "La supervisión bilingüe hizo una gran diferencia. La comunicación fue clara desde el primer día.", name: "Empresa de jardinería", role: "Florida" },
  ],
};

export const WORKER_FORM = {
  en: {
    kicker: "For Workers",
    title: "Looking for H-2A work?",
    subtitle:
      "We are a U.S. employer's contractor — opportunities are limited and seasonal. Fill out this short form and we'll reach out if your profile matches an upcoming H-2A season.",
    fields: {
      full_name: "Full name",
      email: "Email",
      phone: "Phone (WhatsApp preferred)",
      country: "Country of residence",
      age: "Age",
      languages: "Languages you speak",
      years_experience: "Years of work experience",
      crop_experience: "Crops / work experience (e.g., cherries, apples, vegetables)",
      has_passport: "Do you have a passport?",
      prior_visa: "Have you had an H-2A visa before?",
      available_from: "Available starting (month/year)",
      notes: "Anything else we should know?",
    },
    options: {
      passport: { yes: "Yes", no: "No", in_progress: "In progress" },
      prior: { H2A: "Yes — H-2A", none: "No, first time" },
    },
    submit: "Submit application",
    submitting: "Submitting...",
    success: "Application received. Norberto or Abraham will reach out personally.",
    error: "Could not submit. Please try again or call us directly.",
  },
  es: {
    kicker: "Para Trabajadores",
    title: "¿Buscas trabajo H-2A?",
    subtitle:
      "Somos contratistas para empleadores en EE. UU. — las oportunidades son limitadas y estacionales. Llena este formulario corto y te contactaremos si tu perfil encaja con una temporada H-2A próxima.",
    fields: {
      full_name: "Nombre completo",
      email: "Correo",
      phone: "Teléfono (WhatsApp preferido)",
      country: "País de residencia",
      age: "Edad",
      languages: "Idiomas que hablas",
      years_experience: "Años de experiencia laboral",
      crop_experience: "Cultivos / experiencia (ej.: cerezas, manzanas, hortalizas)",
      has_passport: "¿Tienes pasaporte?",
      prior_visa: "¿Has tenido una visa H-2A antes?",
      available_from: "Disponible a partir de (mes/año)",
      notes: "¿Algo más que debamos saber?",
    },
    options: {
      passport: { yes: "Sí", no: "No", in_progress: "En trámite" },
      prior: { H2A: "Sí — H-2A", none: "No, primera vez" },
    },
    submit: "Enviar solicitud",
    submitting: "Enviando...",
    success: "Solicitud recibida. Norberto o Abraham te contactarán personalmente.",
    error: "No se pudo enviar. Inténtelo de nuevo o llámenos directamente.",
  },
};
